import { useMutation } from "@tanstack/react-query";
import instance from "./axiosInstance";

const ENDPOINT = "/postnummer";

export enum PostnummerQueryKey {
  GuessKommun = "guess-kommun",
}

export const useGuessKommun = () =>
  useMutation({
    mutationFn: async ({
      postnummer,
    }: {
      postnummer: string;
    }): Promise<string> => {
      const response = await instance.post(`${ENDPOINT}/${postnummer}`);
      return (response.data ?? "").toString();
    },
  });
